module.exports = "/assets/images/frozen.png";